<template>
  <v-app v-if="!langLoading">
    <v-navigation-drawer
      v-if="currentRouteName != 'login' && currentRouteName != 'gln' && currentRouteName != 'forgotPassword' && currentRouteName != 'resetPassword'"
      color="white" permanent app>
      <v-toolbar-title style="cursor: pointer; height: 64px; gap: 8px;" @click="$router.push('/').catch(() => { })"
        class="d-flex align-center justify-center">
        <v-img lazy-src="@/assets/logo.png" max-height="24" max-width="32" src="@/assets/logo.png"></v-img>
        <span class="xx-toolbar-title ml-2">
          Customer dashboard
        </span>
      </v-toolbar-title>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item text class="menu" @click="openOrders = !openOrders">
          <svg-icon type="mdi" :path="cartPath" class="mr-2" />
          {{ $t('GENERAL.orders') }}
          <v-icon style="right: 0; position: absolute;">{{ openOrders ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
        </v-list-item>
        <ul class="subMenu" v-if="openOrders">
          <li>
            <a href="#/dashboard" :class="currentRouteName == 'dashboard' ? 'current-link' : ''">
              <span class="menuStick"></span>
              {{ $t('GENERAL.openOrders') }}
            </a>
          </li>
          <li>
            <a href="#/order-history" :class="currentRouteName == 'orderHistory' ? 'current-link' : ''">
              <span class="menuStick"></span>
              {{ $t('GENERAL.ordersSubmitted') }}
            </a>
          </li>
        </ul>
        <!-- Temporary hidden -->
        <!--
        <v-list-item  :to="{ name: 'mediaLibrary' }" active-class="current-link" class="menu">
          <v-icon class="mr-2">mdi-image-multiple</v-icon>
          {{ $t('GENERAL.mediaLibrary') }}
        </v-list-item>-->
      </v-list>
      <template v-slot:append>
        <v-divider class="sidebar-bottom-divider"></v-divider>
        <div class="justify-center d-flex pa-3">
          <v-menu v-model="showNewMenu" top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="options-btn" v-bind="attrs" v-on="on">
                {{ $te('GENERAL.new') ? $t('GENERAL.new') : 'New' }}
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <!-- I5618: one entry for the aanmeldformulier, packaging and marketing files -->
              <v-list-item class="upload-files-menu" @click="openUploadGLNModal">
                <v-list-item-title>{{ uploadFilesLabel }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- GLN Selection Modal for UPLOAD FILES (I5618) -->
    <v-dialog v-model="showUploadGLNModal" max-width="500px">
      <company-selector
        :show-cancel="false"
        :initial-company="clientInfo"
        @company-selected="handleUploadGLNSelected"
      />
    </v-dialog>

    <v-app-bar app color="white" elevate-on-scroll>
      <v-container class="d-flex align-center py-0">
        <v-spacer></v-spacer>
        <div style="position: relative;" class="d-flex align-center " v-if="clientInfo && !showGLNSearch" @click="() => {
          if (isGLNSwitchAvailable) {
            showGLNSearch = true;
          }
        }">
          <div class="circleCompany">
            <span style="margin: auto; padding-top: 2px;">{{ clientInfo.companyName?.substring(0, 2) }}</span>
          </div>
          <p class="d-flex flex-column text-end mb-0 mr-12">
            <span class="user-name">{{ clientInfo.companyName }}</span>
            <span class="user-position">{{ clientInfo.informationProvider }}</span>
          </p>
          <v-icon
            style="right: 0; position: absolute; height: 32px; width: 56px; color: #9E9E9E;">mdi-menu-down</v-icon>
        </div>
        <div class="d-flex align-center" v-if="isGLNSwitchAvailable && showGLNSearch">
          <v-autocomplete rounded class="searchGLN" :loading="loading" v-model="selectedClient" :items="clientsList"
            autofocus="true" item-text="companyName" item-value="companyName" @blur="closeGLNSearch"
            @update:search-input="updateGLN" return-object>
            <template v-slot:item="data">
              <div class="client-list-item py-2">
                <span class="font-weight-light">{{ data.item.companyName }}</span>
                <br />
                <span class="primary--text font-weight-medium">{{ data.item.informationProvider }}</span>
              </div>
            </template>
          </v-autocomplete>

        </div>
        <v-menu left bottom offset-y>
          <template v-slot:activator="{ on: menuOn }">
            <v-btn v-on="menuOn" fab text color="grey">
              {{ selectedLang }}
              <v-icon style="right: 0; position: absolute; ">{{ menuOn ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="lang in languages" :key="lang">
              <v-list-item-title @click="updateLang(lang)" class="grey--text text-uppercase" style="cursor: pointer">{{
                lang }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>

    <v-main class="pb-8">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import CompanyService from '@/api/company/companyService.js';
import { formBus } from '@/main.js';
import { loadLanguageAsync, loadLanguagesListAsync, setI18nLanguage } from './i18n.js';
import { useTitle } from '@vueuse/core';
import apiInst from './api/api.js';
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiVectorArrangeBelow, mdiCartOutline, mdiBullhorn } from '@mdi/js'
import CompanySelector from '@/components/CompanySelector.vue'

export default {
  name: 'App',
  components: {
    SvgIcon,
    CompanySelector
  },
  data: () => ({
    path: mdiVectorArrangeBelow,
    cartPath: mdiCartOutline,
    megaphonePath: mdiBullhorn,
    openedMenu: false,
    showNewMenu: false,
    showGLNSearch: false,
    showUploadGLNModal: false,
    clientsList: null,
    selectedClient: null,
    clientsListError: null,
    openOrders: true,
    langLoading: true,
    languages: [],
    clientInfo: JSON.parse(localStorage.getItem('client')),
    isGLNSwitchAvailable: JSON.parse(localStorage.getItem('generalCompany')) == 'XXtract'
  }),

  computed: {
    // I5618: the translation key may not exist yet; then the inline text per language.
    uploadFilesLabel() {
      if (this.$te('UPLOAD.title')) return this.$t('UPLOAD.title');
      return (this.$i18n && this.$i18n.locale) === 'nl' ? 'Bestanden uploaden' : 'Upload files';
    },
    currentRouteName() {
      return this.$route.name;
    },
    selectedLang() {
      return this.$store.getters['language/getLanguage'];
    },
    isLoggedIn() {
      return this.clientInfo !== null;
    },
    mediaUrl() {
      return process.env.VUE_APP_MEDIA_URL;
    },
    version() {
      return process.env.LAST_COMMIT_SHA;
    },
  },

  watch: {
    $route(next, prev) {
      if (prev.name === 'gln' && next.name === 'dashboard') {
        this.loadZohoChat();
        this.getClientsList();
        this.getTooltips();
      }
      if (prev.name === 'login' && next.name === 'dashboard') {
        this.loadZohoChat();
        this.getTooltips();
      }
    }
  },

  async beforeCreate() {
    try {
      await loadLanguageAsync();
    } catch (e) {
      console.log('LANG', e);
    } finally {
      this.langLoading = false;
    }
  },

  created() {
    if (this.isLoggedIn) {
      this.loadZohoChat();
      this.getTooltips();
    }
    this.getClientsList();
    this.setLanguagesList();
    formBus.$on('clientAdd', this.setClientInfo);
    document.addEventListener('wheel', this.handleScroll);
    const lang = localStorage.getItem('language') || 'en';
    this.updateLang(lang);
    setI18nLanguage(lang);

  },

  methods: {
    // I5618: "Bestanden uploaden" keeps the company choice, then opens the single upload page.
    openUploadGLNModal() {
      this.showUploadGLNModal = true;
    },
    handleUploadGLNSelected(selectedCompany) {
      localStorage.setItem('client', JSON.stringify(selectedCompany));
      this.clientInfo = selectedCompany;
      formBus.$emit('clientAdd');
      this.showUploadGLNModal = false;
      if (this.currentRouteName !== 'uploadFiles') {
        this.$router.push({ name: 'uploadFiles' });
      }
    },
    getTooltips() {
      apiInst.get('/tooltips').then((response) => {
        const tooltips = response.data.reduce((acc, item) => {
          const { language, entryInstructionsCustomer, toolTipField } = item;
          if (!acc[language]) {
            acc[language] = {};
          }
          if (entryInstructionsCustomer) {
            acc[language][toolTipField] = entryInstructionsCustomer;
          }
          return acc;
        }, {});
        this.$store.commit('language/SET_TOOLTIPS', tooltips);
      });
    },
    closeGLNSearch() {
      this.showGLNSearch = false;
    },
    async getClientsList() {
      try {
        this.loading = true;
        const res = await CompanyService.getClientsList();
        this.clientsList = res.data;
      } catch (error) {
        console.log('Cant get clients list');
        if (!error.response) {
          this.clientsListError = {
            error: 'Failed',
            message: 'Connection timeout'
          };
        } else {
          this.clientsListError = error.response.data;
        }

        setTimeout(() => {
          this.clientsListError = null;
        }, 7000);
      } finally {
        this.loading = false;
      }
    },
    async setLanguagesList() {
      const list = await loadLanguagesListAsync();
      this.languages = list.data;
      await loadLanguageAsync();
      useTitle(this.$t('GENERAL.CustomerDashboard'));
    },
    setClientInfo() {
      this.isGLNSwitchAvailable = JSON.parse(localStorage.getItem('generalCompany')) == 'XXtract';
      this.clientInfo = JSON.parse(localStorage.getItem('client'));
    },
    updateGLN() {
      if (this.selectedClient) {
        localStorage.setItem('client', JSON.stringify(this.selectedClient));
        formBus.$emit('clientAdd');
        this.showGLNSearch = false;
        window.location.reload();
      }
    },
    async updateLang(lang) {
      await loadLanguageAsync(lang);
      this.$store.dispatch('language/updateLanguage', lang);
      useTitle(this.$t('GENERAL.CustomerDashboard'));
    },
    loadZohoChat() {
      var scripts = [
        "zohochat"
      ];
      scripts.forEach(script => {
        let tag = document.createElement("script");
        if (script.includes("zohochat")) {
          if (document.getElementById("zsiqchat") === null) {
            tag.setAttribute("id", "zsiqchat");
            tag.innerHTML = 'var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "00f33205e195e32084969fefc7d2a574c93d49f8bce31ceeb8f8f427eac76f22", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.eu/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);';
          } else {
            console.log("Zoho Chat already loaded")
          }
        } else {
          tag.setAttribute("src", script);
        }
        document.body.appendChild(tag);
      });
    },
  }
};
</script>

<style lang="scss">
.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active {
  border-radius: 0 !important;

}

.dropdownList {
  padding: 0;
  border: 1px solid #858585 !important;
  border-radius: 0 !important;
  overflow: hidden;
}

.options-btn {
  border-radius: 12px;
  margin: 12px 0;
}

.addProductLink {
  width: 100%;
  display: flex;
  text-decoration: none;
  color: #858585 !important;

  >.v-list-item.theme--light {
    color: unset !important;
  }

  &:hover {
    color: black !important;
    background-color: #f5f5f5 !important;
  }
}

.theme--light.v-list-item {
  &:hover {
    color: black !important;
  }
}

.theme--light.v-list-item--active::before {
  opacity: 0 !important;
}

.circleCompany {
  height: 40px;
  width: 40px;
  background-color: #53959f;
  border-radius: 50%;
  display: inline-flex;
  color: white;
  margin-right: 16px;
}

.menu {
  color: #858585 !important;
}

.current-link {
  color: black !important;
}

.no-active:before {
  background-color: unset !important;
}

.searchGLN {
  width: 300px;
  margin-right: 16px;

  .v-text-field__details {
    display: none !important;
  }

  .v-input__slot {
    margin-bottom: 0px;
    padding: 0 !important;
  }
}

.no-decoration {
  text-decoration: none !important;
}

.subMenu {
  text-decoration: none;
  list-style: none;
  margin-left: 16px;
  margin-top: 8px;
  margin-bottom: 8px;

  a {
    text-decoration: none;
    color: #858585 !important;
  }

  .current-link {
    color: black !important;
  }

  li {
    cursor: pointer;
    /* You need to turn on relative positioning so the line is placed relative to the item rather than absolutely on the page */
    position: relative;

    /* Use padding to space things out rather than margins as the line would get broken up otherwise */
    margin: 0;
    padding-left: 25px;
    padding-bottom: 10px;
    padding-top: 10px;

    &:hover {
      background-color: #FAFAFA;

      >a {
        color: black !important;
      }
    }
  }

  li:before {
    background-color: #D4D4D4;
    width: 1px;
    content: '';
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 5px;
  }

  .menuStick {
    background-color: #D4D4D4;
    height: 1px;
    content: '';
    position: absolute;
    top: 21px;
    bottom: 0px;
    left: 5px;
    right: 90%;
  }

  li:last-child:before {
    background-color: #D4D4D4;
    width: 1px;
    content: '';
    position: absolute;
    top: 0px;
    bottom: 22px;
    left: 5px;
  }

}

.vertical-divider {
  height: 50px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  border-left: 1px solid lightgrey;
}

.v-btn--active.no-active::before {
  opacity: 0 !important;
}

$font-family: '-apple-system';

.v-application {
  [class*='text-'] {
    font-family: $font-family, BlinkMacSystemFont, sans-serif !important;
  }

  font-family: $font-family,
  BlinkMacSystemFont,
  sans-serif !important;
}

.user-name {
  font-size: 12px;
  letter-spacing: 0;
}

.user-position {
  font-size: 12px;
  letter-spacing: 0;
  color: #53959f;
}

.user-avatar {
  border: 4px solid #e9ebf4;
  transition: all ease 0.5s;

  &:hover {
    border: 0px solid transparent;
  }
}

.zsiq_floatmain {
  margin-bottom: 120px;
  margin-right: 32px;
}

/* Align sidebar bottom divider with BulkEditActionBar */
.sidebar-bottom-divider {
  margin-bottom: 4px;
}

@import './styles/scss/variables.scss';
@import './styles/scss/mixins.scss';
@import './styles/scss/main.scss';
</style>